import React from 'react'
import styled from 'styled-components'
import Icon1 from '../assets/icon1.svg'
import Icon2 from '../assets/icon2.svg'
import Icon3 from '../assets/icon3.svg'
import Icon4 from '../assets/icon4.svg'
import { Link } from 'react-router-dom';
import Background from '../assets/bg-red-home.png';

const PageContainer = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-image: url(${Background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 50px;
  color: white;
  gap: 60px;
  @media (max-width: 900px) {
    height: auto;
    padding-top:3rem;
    padding-bottom:3rem;
  }
`

const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
  margin-top: 2rem;
  @media (max-width: 900px) {
   flex-direction: column;

  }
`

const MailGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  width: 20%;
  @media (max-width: 900px) {
    width: 100%;
  }
`


const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
`

const LogoIcon = styled.img`
  width: 110px;
  height: 110px;
  margin-bottom:5%;
  margin-top:-7%;
`;

const Title = styled.p`
  font-size: 8rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin: -1.5%;
  z-index:999;
  @media (max-width: 900px) {
    display:none;
  }
`
const TitleMob = styled.p`
display :none;
  @media (max-width: 900px) {
    font-size: 4.5rem;
    color: #fff;
    font-family: 'MongoGrotesqueLight';
    margin: -1.5%;
    z-index:999;
    display:flex;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
   
  }
`

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #ddd;
  font-family: 'PoppinsMedium';
  margin-bottom: 2rem;
  margin-top: 2rem;
z-index:999;
`

const PrimaryButton = styled.button`
    background: #FFE6DA;
    border: 1px solid #333;
    border-radius: 20px;
    text-decoration:none;
    padding: 0.5rem 1.5rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    color: black;
    transition: background-color 0.2s, color 0.2s;
    margin-top: 2rem;

`

const LinkButtons = styled.div`
    display: flex;                       
    gap: 1.5rem;                          
   flex-direction:row;  
    margin-top:2rem;
    font-family: 'PoppinsMedium';  
    @media (max-width: 900px) {
      flex-direction:column;
      align-items:start;
      width:100%;
    }
`

const LinkButton = styled(Link)`
    text-decoration: none;
    color: white;
    background-color:transparent;
    border: none;
    font-weight: 500;
    width: 100%;
    text-align: center;
    font-family: 'PoppinsMedium';
    white-space: nowrap;

`

const ContainerFooterText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
  width: 100%;
  text-align: center;
  gap: 5px;
  @media (max-width: 900px) {
    align-items: center;
    justify-content: center;
  }
`

const Footer = styled.footer`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  flex-direction:row;
  gap:20px;
  font-size: 0.75rem;

  

`

const MicroText = styled.span`
  /* nothing extra */
`

const Item = styled.div`
  width: 100%;
  border-bottom: 1px solid rgba(255,255,255,0.2);
  margin-top:2%;
  @media (max-width: 900px) {
    margin-bottom:2%;
  }
  
`

const IconRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 10px;
  margin-bottom: 2rem;
`

const Icon = styled.img`
  width: 30px;
  height: 30px;
  @media (max-width: 900px) {
    width: 20px;
    height: 20px;
  }
  
`

const FooterPage = () => (
  <PageContainer>
    <Main>
      <IconRow>
        <Icon src={Icon2} alt="Icon 2" />
        <Icon src={Icon3} alt="Icon 3" />
        <Icon src={Icon1} alt="Icon 1" />
        <Icon src={Icon4} alt="Icon 4" />
      </IconRow>
      <Title>REJOIGNEZ L'UNIVERS PARTOUCHE<br/> MULTIVERSE</Title>
      <TitleMob>REJOIGNEZ L'UNIVERS PARTOUCHE MULTIVERSE</TitleMob>
      {/* <Subtitle>Inscrivez-vous gratuitement et profitez d'opportunités exclusives. </Subtitle> */}
      <PrimaryButton  onClick={() => window.open('https://linktr.ee/jokerclubspirit', '_blank')}>Nous rejoindre</PrimaryButton>
      <Header>
        <MailGroup>
          <span style={{fontWeight:'bold'}}>Général</span>
          <span style={{textDecoration:'underline'}}>jokerclub@partouche.com</span>
        </MailGroup>
        <MailGroup>
          <span style={{fontWeight:'bold'}}>SAV</span>
          <span style={{textDecoration:'underline'}}>savjokerclub@partouche.com</span>
        </MailGroup>
        <MailGroup>
          <span style={{fontWeight:'bold'}}>Partenariat</span>
          <span style={{textDecoration:'underline'}}>partenariatjokerclub@partouche.com</span>
        </MailGroup>
      </Header>
      <Item/>
    </Main>
    <Footer>
      <LinkButtons>
        <LinkButton to="/jockerclub">JOKER CLUB</LinkButton>
        <LinkButton to="/aboutus">PARTOUCHE MULTIVERSE</LinkButton>
        <LinkButton to="/">MULTISHOP</LinkButton>
        {/* <LinkButton to="/contactus">CONTACT</LinkButton> */}
        {/* <LinkButton to="/">PRIVACY</LinkButton> */}
      </LinkButtons>
      <ContainerFooterText>
        <MicroText>GROUPE PARTOUCHE 2025</MicroText>
        <MicroText>CRAFTED BY BARY</MicroText>
      </ContainerFooterText>
    </Footer>
  </PageContainer>
)

export default FooterPage
